import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, DialogActions, DialogContent, IconButton } from "@mui/material";
import { ReactNode } from "react";
import Button from "../button/Button";
import useDotLegalDialogStyles from "./DotLegalDialog.styles";

export interface DotLegalDialogProps {
    open: boolean;
    onDialogClose: () => void;
    header: string;
    buttonOkText: string;
    onOkClick: () => void;
    okButtonDisabled?: boolean;
    inProgress?: boolean;
    disableOnClose?: boolean;
    children: ReactNode;
}

// Ported from @dotlegal/dotlegal-ui-components' DotLegalDialog, which hardcoded its close icon color
// and derived its OK button's color from a package-internal DotLegalButton with no way to restyle
// either per-instance. Owning the dialog locally (matching the existing local DotLegalModal) lets it
// use the brand colors directly and lets us drop this last usage of the shared package's dialog.
function DotLegalDialog(props: DotLegalDialogProps) {
    const classes = useDotLegalDialogStyles();

    return (
        <Dialog open={props.open} onClose={props.onDialogClose} disableEscapeKeyDown={props.disableOnClose}>
            {!props.disableOnClose && (
                <Box sx={{ display: "flex", justifyContent: "flex-end", paddingRight: 1, paddingTop: 1 }}>
                    <IconButton aria-label="close" className={classes.dialogCloseButton} onClick={props.onDialogClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            )}
            <Box className={classes.header}>{props.header}</Box>
            <DialogContent className={classes.dialogContent}>{props.children}</DialogContent>
            <DialogActions className={classes.actions}>
                <Box sx={{ margin: 2 }}>
                    <Button buttonType="primary" onClick={props.onOkClick} disabled={props.okButtonDisabled} isLoading={props.inProgress}>
                        {props.buttonOkText}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}

export default DotLegalDialog;
